import React, { useEffect, useState } from 'react'

const EventSectionTabButtons = () => {
    const [events, setEvents] = useState([]);
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const res = await fetch(`https://api.1000siljang.xyz/api/users/events`, {
                    headers: {
                        accept: 'application/json'
                    }
                });
                const data = await res.json();
                setEvents(data.data || data); // if data has a .data field
            } catch (err) {
                console.error("Error fetching events:", err);
            }
        };
        fetchEvents();
    }, []);
    return (
        <>
            <div className='overflow-y-hidden overflow-x-auto'>

                <div className='w-[1200px] lg:w-full text-white h-[45px] flex items-end font-Serif'>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate border-l-slate border-l bg-graphite text-white'>전체 {`(${events.length})`}</button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                    <button className='relative text-center cursor-pointer w-full h-[45px] leading-[45px] border text-sm font-bold border-solid border-slate'></button>
                </div>
            </div>
        </>
    )
}

export default EventSectionTabButtons